import { Badge } from '@acb_devel/design-system';
import type { Registration, RegistrationStatus } from '@services/registrations';
import {
  PopoverRoot,
  PopoverTrigger,
  PopoverContent,
  PopoverClose,
} from '@acb_devel/design-system';
import { AngleDownIcon } from '@acb_devel/design-system';

import { STATUS_MAP } from '@data/registrationStatusMap';

import styles from './RegistrationStatusSwitch.module.scss';

export function RegistrationStatusSwitch({
  registration,
  onStatusChange,
}: {
  registration: Registration;
  onStatusChange: (
    registration: Registration,
    status: RegistrationStatus
  ) => void;
}) {
  function handleStatusChange(
    registration: Registration,
    status: RegistrationStatus
  ) {
    onStatusChange(registration, status);
  }

  return (
    <PopoverRoot>
      <PopoverTrigger>
        <div>
          <Badge
            variant={
              STATUS_MAP.find((s) => s.status === registration.status)?.badge
            }
            className={styles.registrationStatusSwitch}
          >
            <span className={styles.registrationStatusSwitch__badge}>
              {STATUS_MAP.find((s) => s.status === registration.status)?.label}
            </span>
            <AngleDownIcon width={12} />
          </Badge>
        </div>
      </PopoverTrigger>
      <PopoverContent align="start" sideOffset={4}>
        <div className={styles.registrationStatusSwitch__popoverContent}>
          {STATUS_MAP.map(({ status, label, badge }, index) => (
            <PopoverClose key={`status_${status}_${registration.id}_${index}`}>
              <Badge
                variant={badge}
                className={styles.registrationStatusSwitch__badge}
                onClick={() => handleStatusChange(registration, status)}
              >
                {label}
              </Badge>
            </PopoverClose>
          ))}
        </div>
      </PopoverContent>
    </PopoverRoot>
  );
}
